// extracted by mini-css-extract-plugin
module.exports = {"root":"speed-module--root--gUF-a","transfromToLeft":"speed-module--transfromToLeft--EoKyv","text":"speed-module--text--33s6G"};